import { LocalStorageService } from '@/services/localStorageService';
import { CONSTANTS, LOCAL_STORAGE_KEYS } from '@/constants';

export const getCookieAccess = () => {
	const countryCode = LocalStorageService.get(
		LOCAL_STORAGE_KEYS.COUNTRY_CODE,
		'',
	);
	if (countryCode && CONSTANTS.COOKIES_ACCESS_REGION.includes(countryCode)) {
		return true;
	}
	return false;
};
